import { useFormContext } from 'react-hook-form';

import type { ClientCreateInput } from './schemas';

import { FormField } from '@/components/form-field';
import { Label } from '@/components/ui/label';

export const ClientFormFields = () => {
  const { register } = useFormContext<ClientCreateInput>();
  return (
    <>
      <FormField<ClientCreateInput> name="name" label="Название" placeholder="Acme" />
      <FormField<ClientCreateInput> name="description" label="Описание" placeholder="—" />
      <div className="flex items-center gap-2">
        <input id="isInternal" type="checkbox" {...register('isInternal')} className="h-4 w-4" />
        <Label htmlFor="isInternal">Внутренний клиент</Label>
      </div>
    </>
  );
};
